var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchiveTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "archive-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.41 1H3.59C2.525 1 1.66 1.87 1.66 2.93V9.975C1.66 10.875 2.305 11.255 3.095 10.82L5.535 9.465C5.795 9.32 6.215 9.32 6.47 9.465L8.91 10.82C9.7 11.26 10.345 10.88 10.345 9.975V2.93C10.34 1.87 9.475 1 8.41 1Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.795 5.5L5.545 6.25L7.545 4.25",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    opacity: 0,
    d: "M11.25 0.75V11.25H0.75V0.75H11.25Z",
    stroke: "white",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveTick);
export default __webpack_public_path__ + "static/media/archive-tick.ceb03ba306a3fa580813ac7c5682c8c3.svg";
export { ForwardRef as ReactComponent };